// extracted by mini-css-extract-plugin
module.exports = {"containerLoader":"Loader_containerLoader__34cr2","loader":"Loader_loader__1SkX0","rotation":"Loader_rotation__1R4Gs"};